class Accordion
  constructor: (@$elm, @events)->
    @$elm.find('dd').hide()
    @$elm.find('dt:first').addClass('open').next('dd').show()
    @$elm.find('dt').click ->
      $(this).parent('.accordion').find('dt.open').not(this).removeClass('open').next('dd').slideUp('fast')
      $(this).toggleClass('open').next('dd').slideToggle('fast')

module.exports = Accordion
